/*
* Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
* Dual licensed under the MIT and GPL
*
* @author Jaroslav Přibyl (pribyl@cadwork.cz)
*
*/

/**
 * @param aRenderDocument
 * @extends Light
 * @constructor
 */
import RenderDocument from "App/render_document";
import Light from "App/view/lights/light";

export default
class DirectionalLight extends Light {

    public static TypeName: string = "DirectionalLight";

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._typeName = DirectionalLight.TypeName;
    }
}
